import { APP_TYPE, AppType } from "../app.type";
import { AuthService } from "./auth.service";
import { Inject, Injectable } from "@angular/core";
import { REDIRECT_REASON, REDIRECT_TO } from "../routing/routing.service";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { TOKEN } from "./token";
import { StringUtils } from "../../../../shared/utils/string.utils";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    @Inject(APP_TYPE) private app: AppType,
    private authService: AuthService,
    private router: Router
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (this.isPublicPcnRoute(state.url)) {
      return true;
    }

    const storedToken =
      typeof Storage !== "undefined" ? localStorage.getItem(TOKEN) : null;
    const hadToken = !StringUtils.isNullOrEmpty(storedToken);

    const authenticated = await this.authService.checkAuth();

    const segments = state.url.split("/").filter((s) => s !== "");

    if (typeof Storage !== "undefined") {
      sessionStorage.setItem(REDIRECT_TO, JSON.stringify(segments));
    }

    if (!authenticated) {
      if (typeof Storage !== "undefined") {
        if (hadToken) {
          sessionStorage.setItem(REDIRECT_REASON, "SESSION_EXPIRED");
        } else {
          sessionStorage.removeItem(REDIRECT_REASON);
        }
      }

      return this.router.createUrlTree(["/login"]);
    } else {
      return true;
    }
  }

  private isPublicPcnRoute(url: string) {
    const path = url.split(/[?#]/)[0];
    const segments = path.split("/").filter((segment) => segment !== "");

    return segments.length === 2 && segments[1] === "pcn";
  }
}
